import { Dispatch } from 'redux';

import { SideBarTypes } from '../../constants';
import { SidebarParams } from '../../interface';
import { RemoveObjectType } from '../Object';

export const OPEN_SIDEBAR = 'sidebar/OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'sidebar/CLOSE_SIDEBAR';

export type OpenSideBarType = {
	type: typeof OPEN_SIDEBAR;
	sideBarType: SideBarTypes;
	params: SidebarParams;
};

export const openSideBar = (
	sideBarType: SideBarTypes,
	params: SidebarParams = {}
): OpenSideBarType => ({
	type: OPEN_SIDEBAR,
	sideBarType,
	params,
});

export type CloseSideBarType = {
	type: typeof CLOSE_SIDEBAR;
	afterCallback?: Function;
};

export const closeSideBar = (
	afterActions: Array<any> = [],
	afterCallback?: Function
) => {
	return (dispatch: Dispatch<CloseSideBarType | RemoveObjectType>) => {
		dispatch({
			type: CLOSE_SIDEBAR,
			afterCallback,
		});

		afterActions.forEach((item) => dispatch(item));
	};
};

export type Action = OpenSideBarType | CloseSideBarType;
